import { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { styles } from './styles';

interface SearchUserMessageItemProps {
  body: string;
}

export const SearchUserMessageItem: FC<SearchUserMessageItemProps> = ({ body }) => {
  const messageLines = body.split(/\r?\n/);

  return (
    <Box sx={styles.wrap}>
      {messageLines.map((line) => (
        <Typography component="span" sx={styles.textLine} key={line}>
          {line}
        </Typography>
      ))}
    </Box>
  );
};
